<template>
    <div class="page-content header-clear-medium">

		<div class="content mt-0">
			<router-link :to="{ name: 'tatib.data.add' }" class="btn bg-red-dark rounded-xs text-uppercase font-700 w-100 btn-s mb-3">
				<i class="bi bi-plus-lg pe-2 ms-n1"></i>
				Tambah Data
			</router-link>
		</div>

		<div class="card card-style">
			<div class="content">

				<h3 class="text-center mb-3 color-blue-dark">Data Pelanggaran</h3>

				<ReportFilter 
					:type-filter.sync="filterParams.type" 
					:daily-time.sync="filterParams.date" 
					:monthly-time.sync="filterParams.month" 
					:tingkat-filter.sync="filterParams.kelas_id" 
					:rombel-filter.sync="filterParams.rombel_id" 
					:student-filter.sync="filterParams.student_id" 
					:range-date-from.sync="filterParams.date_from" 
					:range-date-to.sync="filterParams.date_to" 
					:month-label.sync="monthLabel"
				/>

				<p class="color-red-dark mb-1 mt-3 font-16">{{ message }}</p>
				<div class="divider"></div>

				<button @click="getDataTatib()" class="btn bg-green-dark rounded-xs text-uppercase font-700 w-100 btn-s mb-3">
					Lihat Data
				</button>
				
				<div v-if="!loading">
					<div  v-if="tatibs.length > 0">
						<div v-for="(item, indexItem) in tatibs" :key="indexItem" class="mt-2">
							<h6 class="text-center font-12">{{ item.date | getDateIndo }}</h6>
							<div class="d-flex">
								<div class="bg-blue-light me-2 px-3 py-1 rounded align-self-start" style="background-color: #284a77 !important;">
									{{ indexItem + 1 }}
								</div>
								<div class="accordion accordion-m border-0 w-100" :id="'accordion-group-'+indexItem">
									<div class="accordion-item border border-fade-highlight bg-gray-light">
										<div class="d-flex flex-column p-2">
											<div class="d-flex justify-content-between">
												<div class="flex-fill bg-blue-dark py-1 px-2 rounded text-center font-data-tatib">{{ item.name }}</div>
												<div class="bg-dark-light ms-2 py-1 px-3 rounded text-center font-data-tatib">{{ item.classroom }}</div>
											</div>
											<div class="d-flex justify-content-between mt-2">
												<div class="flex-fill bg-red-dark py-1 px-2 rounded text-center font-data-tatib">{{ item.clause }}</div>
												<div class="bg-yellow-light ms-2 py-1 px-2 rounded">
													<button class=" color-dark-dark text-start" data-bs-toggle="collapse" :data-bs-target="'#accordion7-'+indexItem">{{ item.detail }} <i class="bi bi-arrow-down-short font-18 ps-2 ms-n1"></i></button>
												</div>
											</div>
											<div class="d-flex justify-content-between mt-2">
												<button @click="sendWhatsapp(item)" class="flex-fill py-2 px-2 rounded text-center font-data-tatib" :class="{ 'bg-gray-dark': item.detailData.is_reminder == 1, 'bg-green-dark' : item.detailData.is_reminder == 0}" :disabled="item.detailData.is_reminder == 1">{{ (item.detailData.is_reminder == 1) ? 'Terkirim' : 'Belum Terkirim' }}</button>
												<div class="d-flex justify-content-between px-2">
													<router-link :to="{ name: 'tatib.data.edit', params: {id: item.id}}" class="btn-success bg-green-dark btn-xs rounded-xs"><i class="bi bi-pencil-square"></i></router-link>
													<button class="btn-danger bg-red-dark btn-xs rounded-xs" @click="deleteItem(item.id)"><i class="bi bi-trash"></i></button>
												</div>
											</div>
											<div class="d-flex justify-content-between mt-2">
												<div class="flex-fill bg-blue-light py-1 px-2 rounded text-center font-data-tatib">Ditambahkan oleh admin {{ item.admin }}</div>
											</div>
										</div>
										<div :id="'accordion7-'+indexItem" class="accordion-collapse collapse" :data-bs-parent="'#accordion-group-'+indexItem">
											<div class="container-fluid">
												<div class="row px-2 pb-3 pt-1">
													<div class="col-12 bg-white border-dark-dark rounded">
														<p class="mb-1 mt-1">Pasal : {{ item.chapter }}</p>
														<p>Ayat : {{ item.clause }}</p>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="alert alert-warning mt-3" v-else>
						Data Tidak Ditemukan!
					</div>
				</div>
				<div v-else>
					<div class="d-flex mt-3" v-for="i in 10" :key="i">
						<vue-skeleton-loader
							:height="30"
							:width="30"
							animation="fade" 
							class="me-2 px-3 rounded align-self-start"
						/>
						<vue-skeleton-loader
							:height="150"
							animation="fade" 
							class="rounded w-100"
						/>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>

<script>
import { 
	mapActions, mapState, mapMutations
} from 'vuex'

import moment from 'moment'
import ReportFilter from '../components/form/ReportFilter.vue'
import $axios from '../services/apiLms'

export default {
	name: 'TatibData',
	components: {
	ReportFilter, 
	},
	data() {
			return {
				monthLabel: '',
				message: '',
				filterParams : {
					type: this.$route.query.type ?? 'daily',
					month: this.$route.query.month ?? moment().format('MM'),
					date: this.$route.query.date ?? moment().format('YYYY-MM-DD'),
					kelas_id: this.$route.query.kelas_id ?? '',
					rombel_id: this.$route.query.rombel_id ?? '',
					student_id: this.$route.query.student_id ?? '',
					date_from: this.$route.query.date_from ?? moment().format('YYYY-MM-DD'),
					date_to: this.$route.query.date_to ?? moment().format('YYYY-MM-DD'),
				},
			}
	},
	async created() {
		this.getDataTatib();
	},
	mounted() {

	},
	updated() {

	},
	methods: {
		...mapMutations(['SET_LOADING', 'CLEAR_LOADING']),
		...mapActions('tatib', ['getTatibs', 'deleteTatibData', 'updateTatipData', 'clearTatibData']),
		async getDataTatib() {
			this.SET_LOADING()
			this.clearTatibData();
			
			let type;
			let time;

			switch (this.filterParams.type) {
				case 'monthly':
					await this.getDataTatibMonthly();
					type = "Bulanan";
					time = this.monthLabel;
					break;
				case 'daily':
					await this.getDataTatibDaily()
					type = "Harian";
					time = this.filterParams.date;
					break;
				case 'all':
					await this.getDataTatibAll()
					type = "Semua";
					time = "Semua";
					break;
				case 'range':
					await this.getDataTatibRange()
					type = "Range Tanggal";
					time = "";
					break;
			}
			this.message = `${type} / ${time} (${this.tatibs.length} Data ditemukan)`;
			this.CLEAR_LOADING()
		},
		async getDataTatibDaily() {
			await this.getTatibs(this.filterParams)
		},
		async getDataTatibMonthly() {
			await this.getTatibs(this.filterParams)
		},
		async getDataTatibRange() {
			await this.getTatibs(this.filterParams)
		},
		async getDataTatibAll() {
			await this.getTatibs(this.filterParams)
		},
		deleteItem(id) {
			this.$swal.fire({
				title: 'Apakah anda yakin?',
				text: "Klik OK untuk melanjutkan!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'OK'
			}).then((result) => {
				if (result.isConfirmed) {
					this.deleteTatibData(id).then(response => {
						console.log(response);
						this.$swal.fire({
							icon: 'success',
							title: 'Berhasil menghapus data',
						});
						this.getTatibs(this.filterParams)	
					}).catch(response => {
						console.log(response);
					});
				}
			})
		},
		async sendWhatsapp(item) {
			const phone = item.detailStudent.nohp_ortu;
			const date = new Date(item.date);
			const dateFormat = moment(date).format('DD-MM-YYYY');
			const message = `Yth. Orangtua dari ananda ${item.detailStudent.nama}, anak anda telah melakukan pelanggaran sekolah pada tanggal ${dateFormat} dengan detail:\nJenis Pelanggaran: ${item.chapter}\nAlasan: ${item.clause}`;
			$axios.post('/operator/send-whatsapp', {
				phone, message, id: item.id
			}).then(async (response) => {
				const data = Object.assign(item.detailData, {
					type: 'student',
					is_reminder: 1
				})
				await this.updateTatipData(data)
			}).catch(response => {
				console.log(response)
			});
		}
	},
	computed: {
		...mapState({
			loading: state => state.loading
		}),
		...mapState('tatib', {
				tatibs: state => state.tatibs,
		}),
	}
}
</script>

<style scoped>
.cursor-pointer { cursor: pointer; }
.font-data-tatib {
	font-size: 14px;
}
</style>
